
import React from "react";
import '../../styles.scss'
import { Box, Button } from "@mui/material";
import '../../../App.css'
import { COLORS } from "../../../constants/colors";
import { Title } from "../../Typography/Title";

export const CustomButton = (props) => {
    const { onClick=()=>{}, translations, language, text, disabled = false, backgroundColor = COLORS.BG_DARK, fontSize = 13 } = props

    return <Button
        sx={{
            color: 'white',
            marginRight: 1,
            backgroundColor: disabled ? COLORS.BG_GRAY_I : backgroundColor,
            '&:hover': {
                color: 'white',
                backgroundColor: disabled ? COLORS.BG_GRAY_I : backgroundColor,
            },
            '&.Mui-disabled': {
                color: 'white',
                backgroundColor: COLORS.BG_GRAY_I,
            },
            width: '100%',
            height: 40,
            borderRadius: 10,
            flexDirection: 'row',
            display: 'flex',
            justifyContent: 'center',
            paddingLeft: 1,
            paddingRight: 1
        }}
        onClick={onClick}
        disabled={disabled}
        disableRipple={true}
        disableFocusRipple={false}
        color={"secondary"}
    >
            <Box sx={{ display: 'flex', 
            
            justifyContent: 'center', alignItems: 'center', width: '100%', borderLeftColor: 'white', whiteSpace: 'nowrap', overflow: 'hidden' }}
                
            >
                <Title
                    uppercase={true}
                    fontWeight={'500'}
                    fontFamily={language === 'geo' ? 'FiraGo' : 'Roboto'}
                    color={'white'}
                    fontSize={disabled ? Math.min(fontSize, 11) : fontSize}
                    style={{ whiteSpace: 'nowrap' }}
                    text={text} />

            </Box>
        </Button>
}